var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "client-medical-reports-page"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Filtrování\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 text-center"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "data-testid": "client-medical-reports-refresh"
    },
    on: {
      "click": function($event) {
        _vm.loadMedicalReportOfClient()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), (_vm.medicalReports.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.medicalReports), function(mr, index) {
    return [_c('tr', {
      staticClass: "row m-0",
      class: _vm.openedMedicalReportId === mr.id ? 'border border-primary border-bottom-0' : '',
      attrs: {
        "data-testid": 'client-medical-report-row-' + mr.id
      }
    }, [_c('td', {
      staticClass: "align-middle col-sm-1"
    }, [(_vm.openedMedicalReportId === mr.id) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "data-testid": 'client-medical-report-toggle-' + mr.id
      },
      on: {
        "click": function($event) {
          _vm.openMedicalReportId(mr.id, mr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": 'client-medical-report-toggle-' + mr.id
      },
      on: {
        "click": function($event) {
          _vm.openMedicalReportId(mr.id, mr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3"
    }, [_vm._v(_vm._s(mr.visit.date))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3"
    }, [_vm._v(_vm._s(mr.visit.planned_for.fullname))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-5"
    })]), _vm._v(" "), (_vm.openedMedicalReportId === mr.id) ? _c('tr', {
      staticClass: "row m-0 border border-primary border-top-0",
      attrs: {
        "data-testid": 'client-medical-report-detail-' + mr.id
      }
    }, [(_vm.editedMedicalReportId === mr.id) ? [_c('td', {
      staticClass: "col-md-6 border"
    }, [_c('b', {
      staticClass: "p-4"
    }, [_vm._v("Původní lékařská zpráva")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace"
      },
      attrs: {
        "id": "medical_report_text"
      },
      domProps: {
        "innerHTML": _vm._s(mr.text)
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "col-md-6 border"
    }, [_c('b', {
      staticClass: "p-4"
    }, [_vm._v("Úprava lékařské zprávy")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-warning",
      on: {
        "click": function($event) {
          _vm.editMedicalReportId(mr.id, mr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" zrušit úpravu")]), _vm._v(" "), _c('div', {
      staticClass: "p-4"
    }, [_c('vue-editor', {
      attrs: {
        "editorToolbar": _vm.customToolbar,
        "data-testid": 'client-medical-report-editor-' + mr.id
      },
      model: {
        value: (_vm.editedMedicalReportText),
        callback: function($$v) {
          _vm.editedMedicalReportText = $$v
        },
        expression: "editedMedicalReportText"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "p-4"
    }, [_c('label', {
      attrs: {
        "for": "printDate"
      }
    }, [_vm._v("Datum tisku:")]), _vm._v(" "), _c('datepicker', {
      attrs: {
        "placeholder": "vybrat datum tisku",
        "format": "dd.MM.yyyy",
        "language": "cs",
        "monday-first": true,
        "full-month-name": true,
        "name": "printDate",
        "id": "printDate",
        "data-testid": 'client-medical-report-print-date-' + mr.id
      },
      model: {
        value: (_vm.editedMedicalReportPrintDate),
        callback: function($$v) {
          _vm.editedMedicalReportPrintDate = $$v
        },
        expression: "editedMedicalReportPrintDate"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "row m-0 p-4"
    }, [(_vm.medicalReportPending === false) ? _c('medical-report-confirm-save', {
      on: {
        "confirmed": function($event) {
          _vm.saveEditedMedicalReport(mr.visit.id)
        }
      }
    }) : _c('button', {
      staticClass: "btn btn-outline-success disabled mr-2",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Uložit")]), _vm._v(" "), (_vm.printMedicalReportPending === false) ? _c('button', {
      staticClass: "btn btn-sm btn-primary mr-2",
      on: {
        "click": function($event) {
          _vm.downloadPdf(mr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-print",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Tisknout")]) : _c('button', {
      staticClass: "btn btn-sm btn-primary disabled mr-2",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Tisknout")]), _vm._v(" "), (_vm.sendMedicalReportPending === false) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      on: {
        "click": function($event) {
          _vm.sendMedicalReport(mr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-mail-forward",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Odeslat e-mailem")]) : _c('button', {
      staticClass: "btn btn-sm btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Odeslat e-mailem")])], 1)])] : _c('td', {
      staticClass: "col-md-12"
    }, [_c('b', {
      staticClass: "p-4"
    }, [_vm._v("Lékařská zpráva")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-warning mr-2",
      attrs: {
        "data-testid": 'client-medical-report-edit-' + mr.id
      },
      on: {
        "click": function($event) {
          _vm.editMedicalReportId(mr.id, mr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" upravit")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "target": "_blank",
        "role": "button",
        "data-testid": 'client-medical-report-print-' + mr.id,
        "href": _vm.hostname.hostname + 'visit/' + mr.visit.id + '/medical_report/pdf'
      }
    }, [_c('i', {
      staticClass: "fa fa-print"
    }), _vm._v(" Tisknout")]), _vm._v(" "), (_vm.sendMedicalReportPending === false) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "data-testid": 'client-medical-report-email-' + mr.id
      },
      on: {
        "click": function($event) {
          _vm.sendMedicalReport(mr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-mail-forward",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Odeslat e-mailem")]) : _c('button', {
      staticClass: "btn btn-sm btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Odeslat e-mailem")]), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace"
      },
      attrs: {
        "id": "medical_report_text"
      },
      domProps: {
        "innerHTML": _vm._s(mr.text)
      }
    })])], 2) : _vm._e()]
  })], 2)])]) : (_vm.medicalReportsPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(2)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Datum návštěvy")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Doktor")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-5"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n            (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (nebyl nalezen žádný výsledek dle požadavků)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f168d90","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/components/ClientMedicalReport.vue
// module id = 657
// module chunks = 0